import { backendClient } from './backend'

export const complianceApi = {
  // License compliance
  getOverview: () =>
    backendClient.get('api/compliance/license/overview'),

  getViolations: (period = '30d', severity = '', page = 1, limit = 50) => {
    let url = `api/compliance/license/violations?period=${period}&page=${page}&limit=${limit}`
    if (severity) url += `&severity=${severity}`
    return backendClient.get(url)
  },

  getViolationDetail: (violationId) =>
    backendClient.get(`api/compliance/license/violations/${violationId}`),

  getFlaggedUsers: (minScore = 40, page = 1, limit = 50) =>
    backendClient.get(`api/compliance/license/flagged-users?min_score=${minScore}&page=${page}&limit=${limit}`),

  getUserCompliance: (userId) =>
    backendClient.get(`api/compliance/license/users/${userId}/compliance`),

  resolveViolation: (userId, violationId) =>
    backendClient.post(`api/compliance/license/users/${userId}/resolve?violation_id=${violationId}`),

  unsuspendUser: (userId) =>
    backendClient.post(`api/compliance/license/users/${userId}/unsuspend`),

  triggerScoring: () =>
    backendClient.post('api/compliance/license/compute-scores'),

  // Document access monitoring
  getTopDocAccessUsers: (period = '24h', limit = 20) =>
    backendClient.get(`api/compliance/doc-access/top-users?period=${period}&limit=${limit}`),

  getDocAccessStats: () =>
    backendClient.get('api/compliance/doc-access/stats'),

  getUserAccessLog: (userId, dateFrom = '', dateTo = '', page = 1, limit = 100) => {
    let url = `api/compliance/doc-access/users/${userId}/access-log?page=${page}&limit=${limit}`
    if (dateFrom) url += `&date_from=${dateFrom}`
    if (dateTo) url += `&date_to=${dateTo}`
    return backendClient.get(url)
  },
}
